import React from 'react';
import type { HSTitleSetting } from '@types';
import Tabbar from '../../Tabbar';
import WidgetRow from '../WidgetRow';
import { IconH } from './IconH';
import { IconV } from './IconV';

type Value = HSTitleSetting['writingMode'];

interface Props {
  value: Value;
  onChange: (val: Value) => void;
}

const values: Value[] = [0, 1];

const getIndex = (val: Value) => values.findIndex((x) => x === val) ?? 0;

export function WidgetRowWrittingMode({ value = 0, onChange }: Props) {
  const tabs = [<IconH active={value === 0} />, <IconV active={value === 1} />];

  return (
    <WidgetRow>
      <div className="mb-10">文字方向：</div>
      <Tabbar
        tabs={tabs}
        tips={['横排', '竖排']}
        activeIndex={getIndex(value)}
        onChange={(index) => onChange(values[index])}
      />
    </WidgetRow>
  );
}
